/** Script name of the Firebase messaging service worker registered from `public/`. */
export const FCM_SERVICE_WORKER_SCRIPT = "firebase-messaging-sw.js";

/**
 * Registered on Firebase's own push scope so it can coexist with the app's
 * Workbox worker at "/" — two workers cannot share one scope.
 */
export const FCM_SERVICE_WORKER_PATH = "/firebase-messaging-sw.js";

export const FCM_SERVICE_WORKER_SCOPE = "/firebase-cloud-messaging-push-scope";
